import React from 'react';
import { B, D, Arr, Lbl, Lane } from '../shared/SvgHelpers';

export default function DiagramGesamtsystem() {
  return (
    <div className="space-y-3" data-testid="diagram-gesamtsystem">
      <h4 className="text-sm font-bold text-indigo-700">1. Gesamt-Systemübersicht — 5 Eingangskanäle</h4>
      <p className="text-xs text-slate-500">Alle Eingangs-Kanäle münden in den zentralen 8D/4D-Workflow mit KI-Unterstützung.</p>
      <svg viewBox="0 0 780 600" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        <Lane x={5} y={5} w={770} h={80} title="KANAL 1: E-Mail (automatisch, IMAP 10s)" color="#2563eb" />
        <Lane x={5} y={95} w={770} h={75} title="KANAL 2: Manuell (Benutzer-Formular)" color="#7c3aed" />
        <Lane x={5} y={180} w={770} h={75} title="KANAL 3: Öffentliches Formular (Kunde, Token)" color="#0891b2" />
        <Lane x={5} y={265} w={770} h={75} title="KANAL 4: TAD-Upload (PDF mit KI-Extraktion)" color="#14b8a6" />
        <Lane x={5} y={350} w={770} h={75} title="KANAL 5: Q3-Intern (Werk-zu-Werk)" color="#d946ef" />
        <Lane x={5} y={435} w={370} h={160} title="VERARBEITUNG" color="#d97706" />
        <Lane x={385} y={435} w={390} h={160} title="8D/4D-WORKFLOW" color="#16a34a" />

        {/* E-Mail */}
        <B x={20} y={24} w={90} h={38} label={"Kunden-\nE-Mail"} color="#2563eb" />
        <Arr x1={110} y1={43} x2={135} y2={43} />
        <B x={135} y={24} w={85} h={38} label={"IMAP\nPolling 10s"} color="#2563eb" />
        <Arr x1={220} y1={43} x2={245} y2={43} />
        <B x={245} y={24} w={90} h={38} label={"KI-Extraktion"} color="#7c3aed" sub="P09" />
        <Arr x1={335} y1={43} x2={365} y2={43} />
        <D x={395} y={43} s={26} label={"Daten\nkomplett?"} color="#d97706" />
        <Arr x1={421} y1={43} x2={450} y2={43} />
        <Lbl x={425} y={36} text="Ja" color="#16a34a" />
        <B x={450} y={24} w={90} h={38} label={"Auto-\nZuordnung"} color="#0891b2" />
        <Arr x1={540} y1={43} x2={570} y2={43} />
        <D x={600} y={43} s={26} label={"Besteh.\nRekl.?"} color="#d97706" />
        <Arr x1={626} y1={43} x2={655} y2={43} />
        <Lbl x={630} y={36} text="Ja" color="#16a34a" />
        <B x={655} y={24} w={115} h={38} label={"Zuordnen\nzu bestehender"} color="#16a34a" />
        <Arr x1={600} y1={69} x2={600} y2={470} />
        <Lbl x={605} y={85} text="Nein → Neue" color="#dc2626" size={8} />

        {/* Manuell */}
        <B x={20} y={112} w={100} h={38} label={"Benutzer\neingeloggt"} color="#7c3aed" />
        <Arr x1={120} y1={131} x2={155} y2={131} />
        <B x={155} y={112} w={110} h={38} label={"Neue Rekl.\nFormular"} color="#7c3aed" />
        <Arr x1={265} y1={131} x2={300} y2={131} />
        <B x={300} y={112} w={125} h={38} label={"13 Pflichtfelder\nausfüllen"} color="#7c3aed" />
        <Arr x1={425} y1={131} x2={460} y2={131} />
        <B x={460} y={112} w={80} h={38} label="Speichern" color="#7c3aed" />
        <Arr x1={540} y1={131} x2={590} y2={470} />

        {/* Öffentliches Formular */}
        <B x={20} y={197} w={100} h={38} label={"Externer\nKunde"} color="#0891b2" />
        <Arr x1={120} y1={216} x2={155} y2={216} />
        <B x={155} y={197} w={115} h={38} label={"Portal\n(Token-Link)"} color="#0891b2" />
        <Arr x1={270} y1={216} x2={305} y2={216} />
        <B x={305} y={197} w={110} h={38} label={"Daten eingeben"} color="#0891b2" />
        <Arr x1={415} y1={216} x2={450} y2={216} />
        <B x={450} y={197} w={80} h={38} label="Absenden" color="#0891b2" />
        <Arr x1={530} y1={216} x2={580} y2={470} />

        {/* TAD (NEU) */}
        <B x={20} y={282} w={105} h={38} label={"TAD-PDF\nUpload"} color="#14b8a6" />
        <Arr x1={125} y1={301} x2={155} y2={301} />
        <B x={155} y={282} w={115} h={38} label={"KI-Extraktion\n(TAD-Service)"} color="#14b8a6" sub="analyze-tad" />
        <Arr x1={270} y1={301} x2={305} y2={301} />
        <B x={305} y={282} w={120} h={38} label={"Auto-Reklamation\nanlegen"} color="#14b8a6" />
        <Arr x1={425} y1={301} x2={460} y2={301} />
        <B x={460} y={282} w={100} h={38} label={"Validierung"} color="#14b8a6" />
        <Arr x1={560} y1={301} x2={585} y2={470} />

        {/* Q3 Intern (NEU) */}
        <B x={20} y={367} w={105} h={38} label={"Werk B\n(Melder)"} color="#d946ef" />
        <Arr x1={125} y1={386} x2={155} y2={386} />
        <B x={155} y={367} w={115} h={38} label={"Q3 anlegen\n(message_type)"} color="#d946ef" />
        <Arr x1={270} y1={386} x2={305} y2={386} />
        <B x={305} y={367} w={115} h={38} label={"Werk A\nverantwortlich"} color="#d946ef" />
        <Arr x1={420} y1={386} x2={455} y2={386} />
        <B x={455} y={367} w={100} h={38} label={"Kostenumbuchung"} color="#d946ef" sub="→ KST A" />
        <Arr x1={555} y1={386} x2={580} y2={470} />

        {/* Verarbeitung */}
        <B x={20} y={455} w={110} h={48} label={"Ticket\nerstellen"} color="#d97706" />
        <Arr x1={130} y1={479} x2={170} y2={479} />
        <D x={210} y={479} s={30} label={"8D oder\n4D?"} color="#d97706" />
        <Arr x1={240} y1={479} x2={280} y2={479} />
        <Lbl x={248} y={470} text="8D" />
        <B x={280} y={458} w={80} h={42} label={"8D\nWorkflow"} color="#16a34a" />
        <Arr x1={210} y1={509} x2={210} y2={535} />
        <Lbl x={218} y={530} text="4D" />
        <B x={170} y={535} w={80} h={30} label="4D Workflow" color="#16a34a" />

        {/* 8D Steps */}
        {['D0', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8'].map((d, i) => {
          const x = 400 + i * 36, y = 450;
          const colors = ['#2563eb', '#4f46e5', '#7c3aed', '#d97706', '#dc2626', '#16a34a', '#0891b2', '#7c3aed', '#16a34a'];
          return (
            <g key={d}>
              <rect x={x} y={y} width={30} height={30} rx={6} fill={colors[i]} opacity={0.15} stroke={colors[i]} strokeWidth={1.3} />
              <text x={x + 15} y={y + 20} textAnchor="middle" fontSize="10" fontWeight="700" fill={colors[i]}>{d}</text>
              {i < 8 && <Arr x1={x + 30} y1={y + 15} x2={x + 36} y2={y + 15} color={colors[i]} />}
            </g>
          );
        })}
        <Arr x1={360} y1={479} x2={400} y2={465} />

        <B x={436} y={488} w={55} h={22} label="KI D2" color="#7c3aed" r={11} />
        <B x={472} y={512} w={55} h={22} label="KI D4" color="#dc2626" r={11} />
        <B x={508} y={488} w={55} h={22} label="KI D5" color="#16a34a" r={11} />
        <Arr x1={463} y1={480} x2={463} y2={488} dashed color="#7c3aed" />
        <Arr x1={499} y1={480} x2={499} y2={512} dashed color="#dc2626" />
        <Arr x1={535} y1={480} x2={535} y2={488} dashed color="#16a34a" />

        <B x={660} y={490} w={105} h={38} label={"PDF Report\n+ Abschluss"} color="#16a34a" />
        <Arr x1={724} y1={465} x2={710} y2={490} />
        <B x={660} y={545} w={105} h={22} label="Benachrichtigung" color="#d97706" r={11} />
        <Arr x1={712} y1={528} x2={712} y2={545} dashed color="#d97706" />
      </svg>
    </div>
  );
}
